export default __webpack_public_path__ + "static/media/anthe-lp_banner130623_1440x270.28c3df4d.webp";